
<div class="phone-content">
    <div class="swiper-wrapper">
        <div>
            <swiper-container
                init="false"
                #swiperEl
                slides-per-view="1"
                free-mode="false"
                slides-offset-before="0"
                slides-offset-after="0"
                space-between="30"
                centered-slides="true"
                [pagination]="{
                clickable: true,
                type: 'bullets',
                el: bullets,
                }"
                [navigation]="{
                enabled: thematicStrategies.length > 1,
                nextEl: nextBtn,
                prevEl: prevBtn,
                }"
            >
                @for (thematicStrategy of thematicStrategies; track thematicStrategy.modelStrategyId) {
                <swiper-slide>
                    <liberro-thematic-strategy-card
                        [thematicStrategy]="thematicStrategy"
                        [variant]="variant"
                        (strategySelected)="onStrategySelected($event)"
                    ></liberro-thematic-strategy-card>
                </swiper-slide>
                }
            </swiper-container>

            <div class="swiper-button-prev" #prevBtn></div>
            <div class="swiper-button-next" #nextBtn></div>
        </div>
        <div class="thematic-swiper-bullets" #bullets></div>
    </div>
</div>
<div class="desktop-content">
    <div class="desktop-strategies-wrapper">
        @for (thematicStrategy of thematicStrategies; track thematicStrategy.modelStrategyId) {
            <liberro-thematic-strategy-card
                [thematicStrategy]="thematicStrategy"
                [variant]="variant"
                (strategySelected)="onStrategySelected($event)"
            ></liberro-thematic-strategy-card>
        }
    </div>
</div>